import { Typography } from 'antd';
import { Row } from 'antd/lib';
import { SimHistoryInfo } from 'domain/entities/SimulateEntity';
import { SimHistoryCard } from './SimHistoryCard';

export const SimHistoryList = ({
    data,
    title,
    detailClick,
    type,
}: {
    data?: SimHistoryInfo[];
    title?: string;
    detailClick?: (data?: SimHistoryInfo) => void;
    type: 'history' | 'beforeSim' | 'confirmSim';
}) => {
    return (
        <>
            <div className=" flex flex-col justify-between items-start w-full px-[30px]">
                {title && (
                    <Typography.Title level={4} className="mt-0">
                        {title}
                    </Typography.Title>
                )}
                <Row className="justify-between items-start w-full">
                    {data?.map((item: SimHistoryInfo, index: number) => {
                        return (
                            <SimHistoryCard
                                key={index}
                                data={item}
                                index={index}
                                hasBorder={index < data.length - 1}
                                detailClick={detailClick}
                                type={type}
                            />
                        );
                    })}
                </Row>
            </div>
        </>
    );
};
